module.exports = __webpack_public_path__ + "img/team-updates.5b523a45.webp";